import { render, staticRenderFns } from "./ShopCode.vue?vue&type=template&id=a20a55ca&scoped=true"
import script from "./ShopCode.vue?vue&type=script&lang=js"
export * from "./ShopCode.vue?vue&type=script&lang=js"
import style0 from "./ShopCode.vue?vue&type=style&index=0&id=a20a55ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20a55ca",
  null
  
)

export default component.exports